import { formatNumber } from '../../utils/numberDisplay'

const BENEFIT_STATUS_SET = new Set([
    'trial',
    'active',
    'cancel_scheduled',
    'cancelScheduled',
    'grace',
    'paymentIssue',
])

const parseDate = (value) => {
    if (!value) return null

    const date = new Date(String(value).replace(' ', 'T'))
    return Number.isNaN(date.getTime()) ? null : date
}

const hasDisplayValue = (value) => value !== undefined && value !== null && value !== ''

export const getMembershipDisplayStatus = (membership = {}) => {
    if (membership.displayStatus) return membership.displayStatus

    const status = membership.status || 'none'
    if (!BENEFIT_STATUS_SET.has(status)) return status

    const benefitUntil = parseDate(membership.benefitUntil)
    if (!benefitUntil) return 'none'

    return benefitUntil <= new Date() ? 'expired' : status
}

export const getMembershipEntitlementLabel = (membership = {}) => {
    if (membership.isEntitled === true || membership.isEntitled === 1) return '있음'
    if (membership.isEntitled === false || membership.isEntitled === 0) return '없음'

    const displayStatus = getMembershipDisplayStatus(membership)
    return ['trial', 'active', 'cancel_scheduled', 'cancelScheduled'].includes(displayStatus) ? '있음' : '없음'
}

export const getMembershipTrialLabel = (membership = {}) => {
    if (getMembershipDisplayStatus(membership) === 'trial') return '진행 중'
    if (membership.isTrial === 1) return '이력 있음'
    return '아니오'
}

export const formatMembershipPlanPrice = (priceKrw) => {
    return hasDisplayValue(priceKrw) ? `${formatNumber(priceKrw)}원` : '-'
}

export const formatMembershipPaidAmount = ({ paidAmount, currency } = {}) => {
    if (!hasDisplayValue(paidAmount)) return '-'

    return `${formatNumber(paidAmount)}${currency ? ` ${currency}` : ''}`
}
